export default __webpack_public_path__ + "351f2bec82248cc7730685043e3a39a5.png";